<template lang="pug">
  .months
    h2 {{ i18n('months') }}
    ul
      li(
        v-for="month in monthList" :key="month.key"
        )
        card-front(
          :number="month.number"
          :title="month.title[locale]"
          :text="month.data ? month.data.description[locale] : ''"
          )
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

import CardFront from '@/components/CardFront'

export default {
  name: 'months',
  components: {
    CardFront
  },
  mounted() {
    this.listNumbers();
    this.listMonths();
  },
  computed: {
    ...mapGetters('locale', ['i18n']),
    ...mapState('locale', ['locale']),
    ...mapState('weekdays', ['months']),
    monthList() {
      return this.months
        .map(month => {
          month.number = this.getMonthNumber(month);
          return month;
        })
        .sort((a, b) => a.value - b.value);
    }
  },
  methods: {
    ...mapActions('weekdays', ['listMonths', 'listNumbers']),
    ...mapGetters('weekdays', ['numberByKey']),
    getMonthNumber(month) {
      return this.numberByKey()(month.data.key);
    }
  }
}
</script>

<style lang="stylus" scoped>
  .months
    margin 1rem
  ul
    margin 0
    padding 0
    list-style none
    display flex
    flex-wrap wrap
    justify-content center
  li
    margin .5rem
</style>
